module.exports = __webpack_public_path__ + "static/media/left-arrow.d5f4b911.svg";